import React from "react";

export default function NotFound() {
  return <h1>404,Nothing is here</h1>;
}
